import React from "react";
import { SignUp as SignupComponent } from "../components/Auth";
import { useTitle } from "../hooks";

const Signup = () => {
  useTitle("Sign Up For Train GRC Academy");
  return <SignupComponent />;
};

export default Signup;
